/* ==============================================================================
   LG HOME — comportamiento de las secciones de la home
   1. Pestañas de productos accesibles ([data-lg-tabs], patrón WAI-ARIA tabs).
   2. Botones «Pregunta al asesor IA» ([data-lg-open-chat]): abren el chat de
      Shopify Inbox (con su asistente IA). Buscan su botón dentro del shadow
      root del widget; si aún no ha cargado reintentan unos segundos y, si no,
      muestran un aviso que señala el botón «Chat».
   Se carga con defer desde varias secciones: la guarda evita doble inicio.
   ============================================================================== */
(function () {
  if (window.lgHomeInit) return;
  window.lgHomeInit = true;

  /* ── 1. Pestañas ─────────────────────────────────────────────────────────── */
  function initTabs(root) {
    if (root.dataset.lgTabsReady) return;
    root.dataset.lgTabsReady = 'true';
    const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;

    function select(tab, focus) {
      tabs.forEach(function (t) {
        const selected = t === tab;
        t.setAttribute('aria-selected', selected ? 'true' : 'false');
        t.tabIndex = selected ? 0 : -1;
        const panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !selected;
      });
      if (focus) tab.focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        select(tab, false);
      });
      tab.addEventListener('keydown', function (e) {
        let next = null;
        if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        else if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') next = tabs[0];
        else if (e.key === 'End') next = tabs[tabs.length - 1];
        if (next) {
          e.preventDefault();
          select(next, true);
        }
      });
    });
  }

  /* ── 2. Abrir el chat ────────────────────────────────────────────────────── */
  // Shopify Inbox (con su asistente IA) monta el botón «Chat» en un custom
  // element con shadow root: <div id="shopify-chat"><inbox-online-store-chat>.
  const INBOX_HOSTS = 'inbox-online-store-chat, #shopify-chat, #ShopifyChat, [id^="shopify-chat" i]';
  const INBOX_BUTTONS = ['button.chat-toggle', 'button[class*="toggle" i]', 'button[aria-label]', 'button'];

  // Otros lanzadores genéricos por si algún día se cambia de app.
  const LAUNCHER_SELECTORS = [
    'button.chat-toggle',
    'button[aria-label*="chat" i]',
    'button[title*="chat" i]',
    '[class*="launcher" i] button',
    'button[class*="launcher" i]',
    '[role="button"][aria-label*="chat" i]'
  ];

  function isOwn(el) {
    return !!(el.closest && el.closest('[data-lg-open-chat], .lg-ai, .lg-fanf, .lg-faq'));
  }

  function findIn(root, selectors) {
    for (let i = 0; i < selectors.length; i++) {
      let found = null;
      try {
        found = Array.from(root.querySelectorAll(selectors[i])).find(function (el) {
          return !isOwn(el);
        });
      } catch (err) {
        found = null; // selector no válido en este navegador
      }
      if (found) return found;
    }
    return null;
  }

  function shadowHosts(root) {
    return Array.from(root.querySelectorAll('*')).filter(function (el) {
      return el.shadowRoot;
    });
  }

  function findInbox() {
    const hosts = Array.from(document.querySelectorAll(INBOX_HOSTS));
    for (let i = 0; i < hosts.length; i++) {
      // el propio host o un custom element dentro del contenedor
      const candidates = [hosts[i]].concat(shadowHosts(hosts[i]));
      for (let j = 0; j < candidates.length; j++) {
        const sr = candidates[j].shadowRoot;
        if (!sr) continue;
        const btn = findIn(sr, INBOX_BUTTONS);
        if (btn) return btn;
      }
      const light = findIn(hosts[i], INBOX_BUTTONS);
      if (light) return light;
    }
    return null;
  }

  function findLauncher(custom) {
    if (custom) {
      const byCustom = findIn(document, [custom]);
      if (byCustom) return byCustom;
    }
    const inbox = findInbox();
    if (inbox) return inbox;

    const direct = findIn(document, LAUNCHER_SELECTORS);
    if (direct) return direct;

    // Último recurso: shadow roots de hosts que «parecen» un chat
    const chatLike = /chat|inbox|agent|assistant|messenger/i;
    const hosts = shadowHosts(document.body).filter(function (host) {
      return chatLike.test(host.tagName + ' ' + host.id + ' ' + String(host.className));
    });
    for (let i = 0; i < hosts.length; i++) {
      const inShadow = findIn(hosts[i].shadowRoot, LAUNCHER_SELECTORS.concat(['button']));
      if (inShadow) return inShadow;
    }
    return null;
  }

  function showHint(trigger) {
    const scope = trigger.closest('.lg-ai') || document;
    const hint = scope.querySelector('[data-lg-chat-hint]') || document.querySelector('[data-lg-chat-hint]');
    if (!hint) return;
    hint.hidden = false;
    clearTimeout(hint._lgTimer);
    hint._lgTimer = setTimeout(function () {
      hint.hidden = true;
    }, 7000);
  }

  // Inbox carga su widget de forma diferida: si aún no está, reintenta
  // durante ~4 s antes de mostrar el aviso.
  function openChat(trigger) {
    if (trigger.getAttribute('aria-busy') === 'true') return;
    const custom = trigger.getAttribute('data-lg-chat-selector');
    let tries = 0;

    (function attempt() {
      const launcher = findLauncher(custom);
      if (launcher) {
        trigger.removeAttribute('aria-busy');
        // Si el chat ya está abierto no lo cerramos
        if (launcher.getAttribute('aria-expanded') !== 'true') launcher.click();
        return;
      }
      if (++tries < 14) {
        trigger.setAttribute('aria-busy', 'true');
        setTimeout(attempt, 300);
        return;
      }
      trigger.removeAttribute('aria-busy');
      showHint(trigger);
    })();
  }

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-lg-open-chat]');
    if (!trigger) return;
    e.preventDefault();
    openChat(trigger);
  });

  function init() {
    document.querySelectorAll('[data-lg-tabs]').forEach(initTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Editor de temas: re-iniciar al recargar una sección
  document.addEventListener('shopify:section:load', init);
})();
